// IE対応
import 'es6-promise/auto'
import axios from 'axios'
// TODO: 共通化
import { csrfToken } from 'rails-ujs'
axios.defaults.headers.common['X-CSRF-Token'] = csrfToken()

export default class Clinic {
  static addClinicUser (clinicId, params) {
    return axios.post(`/api/clinics/${clinicId}/clinic_users.json`, { clinic_user: params })
  }
  static updateClinicUser (id, params) {
    return axios.put(`/api/clinic_users/${id}.json`, { clinic_user: params })
  }
  static deleteClinicUser (id) {
    return axios.delete(`/api/clinic_users/${id}.json`)
  }
}
